
import { Bar } from "vue-chartjs";
import { emptyLabels, partografYAxis, partografXAxes, partografLayout } from "./partografAxis";

export default {
  extends: Bar,
  props: {
    dataSet: [],
    durasi: [],
    kontraksi: [],
  },
  data() {
    return {
      labels: emptyLabels(),
      chartData: null,
      options: {
        scales: {
          yAxes: [
            partografYAxis({
              suggestedMin: 0,
              suggestedMax: 5,
              stepSize: 1,
            }),
          ],
          xAxes: partografXAxes(),
        },
        layout: partografLayout(),
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  methods: {
    buildChartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: "HIS",
            data: this.kontraksi,
            borderWidth: 1,
            borderColor: "#000",
            backgroundColor: this.durasi,
          },
        ],
      };
    },
    redraw() {
      this.chartData = this.buildChartData();
      this.renderChart(this.chartData, this.options);
    },
  },
  mounted() {
    this.redraw();
  },
  watch: {
    durasi: function () {
      this.redraw();
    },
    kontraksi: function () {
      this.redraw();
    },
  },
};
